import { render } from "./PromoPanelCardBeta.vue?vue&type=template&id=4f330fd9&scoped=true"
import script from "./PromoPanelCardBeta.vue?vue&type=script&lang=js"
export * from "./PromoPanelCardBeta.vue?vue&type=script&lang=js"

import "./PromoPanelCardBeta.vue?vue&type=style&index=0&id=4f330fd9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f330fd9"]])

export default __exports__